import { apiGet, apiPut } from "../../services/apiClient";
import {
  getLocalItem,
  getSessionItem,
  setLocalItem,
  setSessionItem,
} from "../../utils/safeStorage";

const API_BASE =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "";
const ADMIN_ACCESS_KEY = "adminAccessToken";
const LEGACY_ADMIN_ACCESS_KEY = "hv_admin_token";

const parseMessage = async (res) => {
  const text = await res.text();
  if (!text) return res.ok ? "" : "Request failed";
  try {
    const parsed = JSON.parse(text);
    return parsed?.message || text;
  } catch (_) {
    return text;
  }
};

const resolveAdminToken = async (token) => {
  if (token) return token;
  return (
    getSessionItem(ADMIN_ACCESS_KEY) ||
    getLocalItem(ADMIN_ACCESS_KEY) ||
    getSessionItem(LEGACY_ADMIN_ACCESS_KEY) ||
    getLocalItem(LEGACY_ADMIN_ACCESS_KEY) ||
    ""
  );
};

const refreshAdminToken = async () => {
  try {
    const res = await fetch(`${API_BASE}/api/admin/auth/refresh`, {
      method: "POST",
      credentials: "include",
    });
    if (!res.ok) return null;
    const data = await res.json().catch(() => ({}));
    const nextToken = data?.accessToken || data?.token || "";
    if (!nextToken) return null;
    setSessionItem(ADMIN_ACCESS_KEY, nextToken);
    setLocalItem(ADMIN_ACCESS_KEY, nextToken);
    setSessionItem(LEGACY_ADMIN_ACCESS_KEY, nextToken);
    setLocalItem(LEGACY_ADMIN_ACCESS_KEY, nextToken);
    return nextToken;
  } catch {
    return null;
  }
};

const requestMultipart = async (method, path, formData, token) => {
  const effectiveToken = await resolveAdminToken(token);
  const doFetch = (authToken) =>
    fetch(`${API_BASE}${path}`, {
      method,
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
      credentials: "include",
      body: formData,
    });

  let res = await doFetch(effectiveToken);
  if (res.status === 401) {
    const refreshed = await refreshAdminToken();
    if (refreshed) {
      res = await doFetch(refreshed);
    }
  }

  if (!res.ok) {
    const message = await parseMessage(res);
    const err = new Error(message || "Request failed");
    err.status = res.status;
    throw err;
  }

  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const listHeroSliderBanners = async (token) => {
  const res = await apiGet("/api/admin/hero-banners", token);
  return res?.data || res || [];
};

export const updateHeroSliderBanner = async (id, payload, token) => {
  if (!id) throw new Error("Hero banner id is required");
  return apiPut(`/api/admin/hero-banners/${id}`, payload, token);
};

export const uploadHeroSliderAsset = async (id, file, slot, token) => {
  if (!id) throw new Error("Hero banner id is required");
  if (!file) return "";
  const form = new FormData();
  form.append("file", file);
  const slotQuery =
    slot !== undefined && slot !== null && Number.isFinite(Number(slot))
      ? `?slot=${slot}`
      : "";
  const res = await requestMultipart(
    "POST",
    `/api/admin/hero-banners/${id}/upload${slotQuery}`,
    form,
    token
  );
  return res?.image_url || res?.video_url || res?.data?.image_url || res?.data?.video_url || "";
};


